import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltroDataComponent } from '../../../../shared/filtro-data/filtro-data.component';
import { FiltroService } from '../../../../shared/filtro/filtro.service';
import { FormatarData } from '../../../../shared/formatarData';

@Component({
  selector: 'app-rmpv-passagem-filtro',
  templateUrl: './rmpv-passagem-filtro.component.html',
  styleUrls: ['./rmpv-passagem-filtro.component.css']
})

export class RmpvPassagemFiltroComponent implements OnInit {

  @Input() filtros: any;
  mercados = [];
  gruposEconomicos = [];
  regioes = [];
  regionais = [];
  dealers = [];
  funcao = [];
  Sysdate: FiltroDataComponent = new FiltroDataComponent;
  InicialData; // Set the first Day of month
  dataInicialFormata;
  FinalData; // set the last day of query
  dataFinalFormata;

  max;       // Set a valid date

  habGrupoEconomico = false;
  habDealer         = false;
  habRegiao         = false;
  habRegional       = false;

  parametrosFiltro: any;

  constructor(private peca: FiltroService, router: Router, private route: ActivatedRoute) {
    const max = new Date();
    this.max = { 'year': max.getFullYear(), 'month': max.getMonth() + 1, 'day': max.getUTCDate() };

    
    this.route.queryParams.subscribe(params => {
      this.parametrosFiltro = params;
      this.setaValorData(params['data_inicial'], params['data_final']);
    });
  }

  ngOnInit() {
    this.preencherMercados();
    this.preencherGruposEconomicos();
    this.preencherRegioes();
    this.preencherRegionais();
    this.preencherDealers();
  }

  setaValorData(dataInicial: Date, dataFinal: Date) {
    const dt = new Date();
    if (dataInicial === undefined || dataInicial.toString() === '') {
      const dt = new Date();
      const dataInicial = { 'year': dt.getFullYear(), 'month': dt.getMonth() + 1, 'day': 1 };
      this.dataInicialFormata = new FormatarData(dataInicial.year, dataInicial.month, dataInicial.day, 0, 0, 0).getDataString();
      this.InicialData = dataInicial;
    } else {
      const now = new Date(dataInicial);
      this.InicialData = {'year': now.getUTCFullYear(), 'month': now.getMonth() + 1, 'day': now.getDate() };
    }

    if (dataFinal === undefined || dataFinal.toString() === '') {
      const dataFinal = { 'year': dt.getFullYear(), 'month': dt.getMonth() + 1, 'day': dt.getUTCDate()};
      this.dataFinalFormata = new FormatarData(dataFinal.year, dataFinal.month, dataFinal.day, 0, 0, 0).getDataString();
      this.FinalData = dataFinal;
    } else {
      const now = new Date(dataFinal);
      this.FinalData = {'year': now.getUTCFullYear(), 'month': now.getMonth() + 1, 'day': now.getDate() };
    }

    this.filtros = { data_inicial: this.InicialData, data_final: this.FinalData };
  }

  preencherMercados() {
    this.peca.buscar('mercado')
      .then(r => { this.mercados = r.filtros; });
  }

  preencherGruposEconomicos() {
    this.peca.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  preencherRegioes() {
    this.peca.buscar('regiao')
      .then(r => { this.regioes = r.filtros; });
  }

  preencherRegionais() {
    this.peca.buscar('regional')
      .then(r => { this.regionais = r.filtros; });
  }

  preencherDealers() {
    if (this.GrupoEconomico !== '') {

      this.peca.buscar('dealerGrupo/'.concat(this.GrupoEconomico))
        .then(r => { this.dealers = r.filtros; });

    } else {

      this.peca.buscar('dealer')
        .then(r => { this.dealers = r.filtros; });
    }
  }

  selecionaDealer() {
    this.dealers = [];

    this.preencherDealers();
  }

  set Mercado(id: any) { this.filtros.mercado = this.tratarSetDropDown(id); }
  get Mercado(): any { return this.tratarGetDropDown(this.filtros.mercado); }

  set GrupoEconomico(id: any) { this.filtros.grupo_economico = this.tratarSetDropDown(id); }
  get GrupoEconomico(): any { return this.tratarGetDropDown(this.filtros.grupo_economico); }

  set Regiao(id: any) { this.filtros.regiao = this.tratarSetDropDown(id); }
  get Regiao(): any { return this.tratarGetDropDown(this.filtros.regiao); }

  set Regional(id: any) { this.filtros.regional = this.tratarSetDropDown(id); }
  get Regional(): any { return this.tratarGetDropDown(this.filtros.regional); }

  set Dealer(id: any) { this.filtros.dealer = this.tratarSetDropDown(id); }
  get Dealer(): any { return this.tratarGetDropDown(this.filtros.dealer); }

  set Funcao(id: any) { this.filtros.funcao = this.tratarSetDropDown(id); }
  get Funcao(): any { return this.tratarGetDropDown(this.filtros.funcao); }

  set DataInicial(data) { this.filtros.data_inicial = this.getDataString(data);  }
  get DataInicial(): any {return this.tratarGetDropDown(this.filtros.data_inicial); }

  set DataFinal(data) { this.filtros.data_final = this.getDataString(data);  }
  get DataFinal(): any {return this.tratarGetDropDown(this.filtros.data_final); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  set dataInicial(data) {
    this.filtros.data_inicial = this.getDataString(data);
  }

  set dataFinal(data) {
    this.filtros.data_final = this.getDataString(data);
  }

  limparDataInicial(dataInicialView) {
    dataInicialView._elRef.nativeElement.value = '';
    this.filtros.data_inicial = '';
  }

  limparDataFinal(dataFinalView) {
    dataFinalView._elRef.nativeElement.value = '';
    this.filtros.data_final = '';
  }

  getDataString(data): any {
    return new FormatarData(
      data.year,
      data.month,
      data.day,
      0,
      0,
      0
    ).getDataString();
  }
  
  desabilitaDealer() {
    if (this.GrupoEconomico !== '') {
        this.habDealer = true;
    } else {
      this.habDealer = false;
    }
  }

  desabilitaGrupoEconomico() {
    if (this.Dealer !== '') {
        this.habGrupoEconomico = true;
    } else {
      this.habGrupoEconomico = false;
    }
  }

  desabilitaRegional() {
    if (this.Regiao !== '') {
        this.habRegional = true;
    } else {
      this.habRegional = false;
    }
  }

  desabilitaRegiao() {
    if (this.Regional !== '') {
        this.habRegiao = true;
    } else {
      this.habRegiao = false;
    }
  }

}

